import { render, staticRenderFns } from "./InstitutionEditTabGeneral.vue?vue&type=template&id=59b3a69d&"
import script from "./InstitutionEditTabGeneral.vue?vue&type=script&lang=js&"
export * from "./InstitutionEditTabGeneral.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionEditTabGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports